import React, { useEffect, useState } from 'react';
import {
  ReferenceInput,
  required,
  SelectInput,
  useTranslate,
} from 'react-admin';
import { Grid } from '@material-ui/core';
import { useForm } from 'react-final-form';
import { PersonType, PersonTypeName } from '../../Utils/enums';
import StableAutocompleteInput from '../../Components/StableAutocompleteInput';

const isRequired = [required()];

const RelatedForm = ({ className = '', ...rest }) => {
  const translate = useTranslate();
  const form = useForm();
  const [personType, setPersonType] = useState(PersonType.PhysicalPerson);
  const [autocompleteKey, setAutocompleteKey] = useState(0);
  const values = form.getState().values;

  useEffect(() => {
    if (rest.record.relatedPerson) {
      setPersonType(PersonType.PhysicalPerson);
      form.change('relatedPerson', rest.record.relatedPerson.id || '');
      form.change(rest.record?.id ? 'personType.id' : 'personType', PersonType.PhysicalPerson);
    } else if (rest.record.relatedLegalPerson) {
      setPersonType(PersonType.LegalPerson);
      form.change('relatedLegalPerson', rest.record.relatedLegalPerson.id || '');
      form.change(rest.record?.id ? 'personType.id' : 'personType', PersonType.LegalPerson);
    }
    form.change('relatedType', rest.record.relatedType?.id || '');
  }, [rest.record]);

  const handlePersonTypeChange = (event) => {
    const selectedValue = event.target.value;
    setPersonType(selectedValue);
    form.batch(() => {
      form.change(
        rest.record?.id ? 'personType.id' : 'personType',
        selectedValue
      );
      form.change('relatedPerson', null);
      form.change('relatedLegalPerson', null);
    });
    setAutocompleteKey((prev) => prev + 1);
  };

  const validateRelatedType = (value) => {
    if (
      (personType === PersonType.LegalPerson || values.legalPerson) &&
      parseInt(value, 10) === 3
    ) {
      return 'Una persona moral no puede tener cónyuge.';
    }
    return undefined;
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <ReferenceInput
          source="relatedType"
          reference="related-types"
          fullWidth
          label={translate('resources.related.fields.relatedType')}
          validate={[required(), validateRelatedType]}
          variant="outlined"
        >
          <SelectInput optionText="name" optionValue="id" />
        </ReferenceInput>
      </Grid>

      <Grid item xs={3}>
        <SelectInput
          defaultValue={personType}
          source={rest.record?.id ? 'personType.id' : 'personType'}
          fullWidth
          helperText="Puedes agregar un relacionado físico o moral."
          label={translate('resources.related.fields.personType')}
          variant="outlined"
          onChange={handlePersonTypeChange}
          choices={[
            { id: PersonType.PhysicalPerson, name: PersonTypeName.PhysicalPerson },
            { id: PersonType.LegalPerson, name: PersonTypeName.LegalPerson },
          ]}
        />
      </Grid>

      <Grid item xs={6}>
        {personType === PersonType.LegalPerson ? (
          <StableAutocompleteInput
            label="Buscar persona moral"
            source="relatedLegalPerson"
            reference="legal-people"
            optionText={(record) =>
              record &&
              `${record.documentNumber} - ${record.businessName}`
            }
            isRequired
            currentPerson={values.person ? values.person : values.legalPerson}
          />
        ) : (
          <StableAutocompleteInput
            label="Buscar persona física"
            source="relatedPerson"
            reference="people"
            optionText={(record) =>
              record &&
              `${record.documentNumber} - ${record.firstName} ${record.fatherLastName}`
            }
            isRequired
            currentPerson={values.person ? values.person : values.legalPerson}
          />
        )}
      </Grid>
    </Grid>
  );
};

export default RelatedForm;